/*Prio 1 muutokset*/

document.addEventListener('DOMContentLoaded', function () {
  let themeHeader = document.querySelector("HEADER.theme-header");
  let themeHeaderParent = themeHeader.parentElement;
  if(themeHeader != null){
    let direction = 1;
    let prevY = window.scrollY;
    document.addEventListener("scroll", (event) => {
      let parentOffset = themeHeaderParent.offsetTop;
      let scrolledPos = window.scrollY;
      let directionCheckAfter = parentOffset + themeHeaderParent.scrollHeight;
      if(themeHeader.classList.contains("custom-sticky")){
         if(scrolledPos <= parentOffset){
            themeHeader.classList.remove("direction-up");
            themeHeader.classList.remove("custom-sticky");
            themeHeaderParent.style.paddingTop = null;
         }
      }
      else{
         if(scrolledPos > parentOffset){
            themeHeaderParent.style.paddingTop = themeHeader.clientHeight+"px";
            themeHeader.classList.add("custom-sticky");
            directionCheckAfter = parentOffset + themeHeaderParent.scrollHeight;
            themeHeader.classList.add("direction-up");
         }
      }

      if(window.scrollY < prevY){
        direction = -1;
      }
      else{
         direction = 1;
      }
      prevY = window.scrollY;
      if(themeHeader.classList.contains("custom-sticky")){
        if(directionCheckAfter < scrolledPos){
           if(direction == -1){
               themeHeader.classList.add("direction-up");
           }
           else{
               themeHeader.classList.remove("direction-up");
           }
        }
      
      }
      
      
    });
  }
  
  
}, false);